<template>
    <div class="columns is-multiline">
        
        <div class="column is-8">
            <div class="field">
                <input type="text" class="input custom-input-size is-medium" placeholder="11.12.13.14" autocomplete="off"/>
                <span class="help">The IP or hostname of your server.</span>
            </div>
        </div>
        
        <div class="column is-4">
            <div class="field">
                <input type="text" class="input custom-input-size is-medium" placeholder="22" autocomplete="off"/>
                <span class="help">Server port. Usually, the default one is 22.</span>
            </div>
        </div>

        <div class="column is-12">
            <div class="field">
                <input type="text" class="input custom-input-size is-medium" placeholder="Server user" autocomplete="off"/>
                <span class="help">This user will be used to take the backups.</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    //
}
</script>
